import styles from './MatchedYesShowcase.module.css';
import { SectionWrapper } from '../shared/SectionWrapper';
import { Chip } from '../shared/Chip';
import { ScriptText } from '../shared/ScriptText';
import { GrainOverlay } from '../shared/GrainOverlay';
import girlImg from '../../assets/images/girl.png';
import manImg from '../../assets/images/man.png';

export function MatchedYesShowcase() {
  return (
    <SectionWrapper className={styles.section}>
      <GrainOverlay />
      <div className={styles.header}>
        <Chip className={styles.bigChip}>Couple Quiz</Chip>
        <h2 className={`display ${styles.title}`}>
          Reveal each other's<br />
          secret <ScriptText rotate={-2}>fantasies.</ScriptText>
        </h2>
        <p className={styles.sub}>
          Both Answer Quiz secretly. If you both want it, it shows up on your shared
          bucket list. If one says no — nobody ever knows.
        </p>
      </div>

      <div className={styles.grid}>
        <div
          className={`${styles.card} ${styles.cardHer}`}
          style={{ '--card-accent': 'var(--accent)' } as React.CSSProperties}
        >
          <div className={styles.cardLabel}>
            <span className={styles.labelDot} style={{ background: 'var(--accent)' }} />
            Her
          </div>
          <div className={styles.imgWrap}>
            <img src={girlImg} alt="Her profile" />
          </div>
          <div className={styles.prompt}>
            Blindfold him, lingerie stripshow slow, grind and edge till someone&apos;s begging
          </div>
          <div className={`${styles.badge} ${styles.badgeHer}`} style={{ background: 'var(--accent)' }}>
            YES ♥
          </div>
        </div>

        <div className={styles.matchBadge}>
          <div className={styles.matchCircle}>
            <span className={styles.matchHeart}>♥</span>
            <ScriptText glow={false} className={styles.matchText}>
              match!
            </ScriptText>
          </div>
        </div>

        <div className={styles.card} style={{ '--card-accent': 'var(--him-purple)' } as React.CSSProperties}>
          <div className={styles.cardLabel}>
            <span className={styles.labelDot} style={{ background: 'var(--him-purple)' }} />
            Him
          </div>
          <div className={`${styles.imgWrap} ${styles.him}`}>
            <img src={manImg} alt="His profile" />
          </div>
          <div className={styles.prompt}>
            Blindfold him, lingerie stripshow slow, grind and edge till someone&apos;s begging
          </div>
          <div className={styles.badge} style={{ background: 'var(--him-purple)' }}>YES ♥</div>
        </div>
      </div>
    </SectionWrapper>
  );
}
